import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { X, Cookie } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';

const CookieConsent = () => {
  const { t } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      // Show banner after a short delay
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const declineCookies = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6 animate-fade-in">
      <div className="max-w-7xl mx-auto">
        <div className="bg-card border border-border rounded-xl shadow-elegant p-6 md:flex md:items-center md:justify-between gap-4">
          <div className="flex items-start gap-4 mb-4 md:mb-0 flex-1">
            <div className="bg-primary/10 p-3 rounded-lg flex-shrink-0">
              <Cookie className="h-6 w-6 text-primary" />
            </div>
            <div className="flex-1">
              <h3 className="text-foreground font-semibold mb-2">
                {t('cookie.message').split('.')[0]}
              </h3>
              <p className="text-sm text-muted-foreground leading-relaxed">
                {t('cookie.message')}
              </p>
            </div>
          </div>
          
          <div className="flex gap-3 md:flex-shrink-0">
            <Button
              variant="outline"
              onClick={declineCookies}
              className="flex-1 md:flex-none"
            >
              {t('cookie.decline')}
            </Button>
            <Button
              onClick={acceptCookies}
              className="flex-1 md:flex-none"
            >
              {t('cookie.accept')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
